import { c as _c } from "react/compiler-runtime";
import type React from 'react';
import { cn } from '../../../../../../../../shared/cn';
type CodeProps = React.ComponentPropsWithoutRef<'code'>;
type PreProps = React.ComponentPropsWithoutRef<'pre'>;
export const mdxMarkdownTypographyStyles = {
  p: 'leading-[24px] whitespace-pre-line font-normal',
  code: 'bg-backgroundTertiary rounded font-mono py-0.5 px-1 break-words',
  h1: 'header !mt-0 mb-4',
  h2: 'header !mt-0 mb-3',
  h3: 'header !mt-0 mb-2',
  blockquote: 'border-l-4 border-algosecondary bg-slate-100 dark:bg-slate-700/50 pl-4 italic text-contentSecondary',
  a: 'text-blue-500 underline',
  ul: 'list-disc list-outside pl-6 [&_ul]:ml-1 [&_ul]:list-[circle]',
  ol: 'list-decimal list-outside pl-6 [&_ol]:ml-1 [&_ol]:list-[lower-alpha]',
  strong: 'font-bold',
  em: 'italic',
  hr: 'border-t border-borderPrimary mt-2',
  table: 'w-full border border-borderPrimary overflow-hidden custom-scrollbar',
  th: 'text-center px-4 py-2 font-bold border-b border-r last:border-r-0 border-borderPrimary',
  td: 'px-3 py-2 border-b border-r border-borderPrimary break-words',
  tr: 'last:border-0 even:bg-backgroundHoverOverlay',
  thead: '',
  tbody: '',
  input: 'mr-2 align-middle accent-algoprimary pointer-events-none ' + '[&:not(:checked)]:opacity-60'
} as const;
export function isMdxBlockFenceCode(className: unknown): boolean {
  if (typeof className === 'string') {
    return className.includes('language-') || className.includes('code-highlight');
  }
  if (Array.isArray(className)) {
    return className.some(c => String(c).includes('language-') || String(c).includes('code-highlight'));
  }
  return false;
}
export function MdxFenceCode(props) {
  const $ = _c(11);
  let className;
  let rest;
  if ($[0] !== props) {
    ({
      className,
      ...rest
    } = props);
    $[0] = props;
    $[1] = className;
    $[2] = rest;
  } else {
    className = $[1];
    rest = $[2];
  }
  if (isMdxBlockFenceCode(className)) {
    let t0;
    if ($[3] !== className || $[4] !== rest) {
      t0 = <code className={className} {...rest} />;
      $[3] = className;
      $[4] = rest;
      $[5] = t0;
    } else {
      t0 = $[5];
    }
    return t0;
  }
  let t0;
  if ($[6] !== className) {
    t0 = cn(mdxMarkdownTypographyStyles.code, className);
    $[6] = className;
    $[7] = t0;
  } else {
    t0 = $[7];
  }
  let t1;
  if ($[8] !== rest || $[9] !== t0) {
    t1 = <code className={t0} {...rest} />;
    $[8] = rest;
    $[9] = t0;
    $[10] = t1;
  } else {
    t1 = $[10];
  }
  return t1;
}
export function MdxFencePre(props) {
  const $ = _c(7);
  let className;
  let rest;
  if ($[0] !== props) {
    ({
      className,
      ...rest
    } = props);
    $[0] = props;
    $[1] = className;
    $[2] = rest;
  } else {
    className = $[1];
    rest = $[2];
  }
  let t0;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = cn("code-block", "markdown-readonly-prism", "overflow-x-auto");
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  let t1;
  if ($[4] !== className || $[5] !== rest) {
    t1 = <div className={t0}><pre className={className} {...rest} /></div>;
    $[4] = className;
    $[5] = rest;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  return t1;
}